<template>
<div class="managerinfo">
    <div class="filters">
        <div class="add">
            <el-button type="primary" @click="handleInvate">邀请管理员</el-button>
            <el-button type="text" @click="handlePowerView">权限详情 ></el-button>
        </div>
        <div class="search">
            <el-input v-model="param.name" placeholder="请输入管理员名称" class="condition" clearable></el-input>
            <el-select v-model="param.usertype" placeholder="全部类型" class="condition" clearable>
                <el-option v-for="item in typeList" :key="item.code" :label="item.name"
                           :value="item.code"></el-option>
            </el-select>
            <el-select v-model="param.status" placeholder="全部状态" class="condition" clearable>
                <el-option v-for="item in statusList" :key="item.code" :label="item.name"
                           :value="item.code"></el-option>
            </el-select>
            <el-button type="primary" plain @click="handleQuery">搜索</el-button>
        </div>
    </div>
    <div class="result-list btn-operate-list">
        <el-table :data="tableData" style="width: 100%" ref="multipleTable">
            <el-table-column prop="datetime" label="加入时间" class-name="left" min-width="120px"></el-table-column>
            <el-table-column prop="subject" label="管理员信息" min-width="180px" class-name="title">
                <template slot-scope="scope">
                    <div class="imageText">
                        <img class="img" v-lazy="scope.row.logourl" :alt="scope.row.name"
                             preview="managerinfo">
                        <span>{{scope.row.name}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="usertypename" label="等级" class-name="center" min-width="80px">
                <template slot-scope="scope">{{scope.row.usertypename}}</template>
            </el-table-column>
            <el-table-column prop="operatorname" label="操作人" class-name="center" min-width="140px"></el-table-column>
            <el-table-column prop="brokeragerateheader" label="审核状态" class-name="center">
                <template slot-scope="scope">
                    <span :class="status(scope.row.status)">{{scope.row.statusname}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" min-width="120px" label-class-name="tr">
                <template slot-scope="scope">
                    <div class="tr">
                        <span class="separator-btn" v-if="scope.row.usertype==1 && scope.row.status==10">
                            <el-button @click="handleDown(scope.row)" type="text" size="small">设为普通管理员</el-button>
                        </span>
                        <span class="separator-btn" v-if="scope.row.usertype==2 && scope.row.status==10">
                            <el-button @click="handleUp(scope.row)" type="text" size="small">设为超级管理员</el-button>
                        </span>
                        <span class="separator-btn" v-if="scope.row.status==1">
                            <el-button @click="handleReject(scope.row)" type="text" size="small">拒绝</el-button>
                        </span>
                        <span class="separator-btn" v-if="scope.row.status==1">
                            <el-button @click="handlePass(scope.row)" type="text" size="small">同意</el-button>
                        </span>
                        <span class="separator-btn"  v-if="scope.row.status==10">
                            <el-button @click="handleDel(scope.row)" type="text" size="small">删除</el-button>
                        </span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background @current-change="_getList" :current-page.sync="page.page"
                       :page-size="page.pageSize"
                       :pager-count="11" layout="prev, pager, next" :total="total">
        </el-pagination>
    </div>
    <powerView ref="powerView"></powerView>
    <invateManagerDialog ref="invateManagerDialog"></invateManagerDialog>
</div>
</template>

<script>
import {brandBusiness} from 'api/enumCode'
import {getAdministratorInfoByHostRole, uploadDeleteAdministratorInfoByHostRole, uploadHostAdministratorAuditInfo, uploadAdministratorInfoTypeByHostRole} from 'api/brandBusiness'
import {sendVerCode} from 'api/api'
import {mapGetters, mapActions} from 'vuex'
import InvateManagerDialog from 'views/brandBusiness/systemSetting/homeSetting/components/invateManagerDialog.vue'
import PowerView from 'views/brandBusiness/systemSetting/homeSetting/components/powerView.vue'
export default {
    name: 'managerinfo',
    data() {
        return {
            page: {
                page: 1,
                pageSize: 10,
                pageCount: 0
            },
            typeList: brandBusiness.managertype,
            statusList: brandBusiness.managerstatus,
            param: {
                hostroletype: 2,
                name: '',
                usertype: '',
                status: ''
            },
            total: 0,
            tableData: [],
            invateUrl: ''
        }
    },
    mounted() {
    },
    methods: {
        init() {
            if (this.invateUrl) return false
            this._getList()
        },
        handleDel(row) {
            this.$confirm('确认删除该管理员', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                let obj = {
                    accountid: row.accountid,
                    hostroletype: row.hostroletype,
                    usertype: row.usertype
                }
                this._del(obj)
            })
        },
        handleReject(row) {
            this.$confirm('确认拒绝该申请', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                let obj = {
                    accountid: row.accountid,
                    hostroletype: 2,
                    rolehostinnerid: '',
                    result: 0
                }
                this._editAuth(obj)
            })
        },
        handlePass(row) {
            this.$confirm('确认通过该申请', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                let obj = {
                    accountid: row.accountid,
                    hostroletype: 2,
                    rolehostinnerid: '',
                    result: 1
                }
                this._editAuth(obj)
            })
        },
        handleDown(row) {
            this.$confirm('确认修改为普通管理员', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                let obj = {
                    accountid: row.accountid,
                    hostroletype: row.hostroletype,
                    usertype: 2
                }
                this._editStatus(obj)
            })
        },
        handleUp(row) {
            this.$confirm('确认修改为超级管理员', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                let obj = {
                    accountid: row.accountid,
                    hostroletype: row.hostroletype,
                    usertype: 1
                }
                this._editStatus(obj)
            })
        },
        handleQuery() {
            this.page.page = 1
            this._getList()
        },
        handleInvate() {
            this.$refs.invateManagerDialog.openDialog(this.invateUrl)
        },
        handlePowerView() {
            this.$refs.powerView.openDialog()
        },
        _editAuth(obj) {
            this.setLoading(true)
            uploadHostAdministratorAuditInfo({
                data: obj,
                success: data => {
                    this.$message.success('审核成功')
                    this.setLoading(false)
                    this._getList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _editStatus(obj) {
            this.setLoading(true)
            uploadAdministratorInfoTypeByHostRole({
                data: obj,
                success: data => {
                    this.$message.success('修改成功')
                    this.setLoading(false)
                    this._getList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _del(obj) {
            this.setLoading(true)
            uploadDeleteAdministratorInfoByHostRole({
                data: obj,
                success: data => {
                    this.$message.success('删除成功')
                    this.setLoading(false)
                    this._getList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList() {
            this.setLoading(true)
            getAdministratorInfoByHostRole({
                data: Object.assign({}, this.page, this.param),
                success: data => {
                    this.tableData = data.data.datalist
                    if (this.page.page === 1 ) this.invateUrl = data.data.cardurl
                    this.total = data.data.pageinfo.datacount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {
        status() {
            return function (value) {
                for (let i = 0; i < brandBusiness.managerstatus.length; i++) {
                    if (value === brandBusiness.managerstatus[i].code) {
                        return brandBusiness.managerstatus[i].cls
                    }
                }
                return value
            }
        },
    },
    components: {
        InvateManagerDialog, PowerView
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.managerinfo {
    .imageText{
        display: flex;
        .img{
            width: 50px;
            height: 50px;
            border-radius: 50%;
            margin-right: 10px;
        }
    }
}
</style>
